/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description S3 File Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { educationalMaterial: educationalElementEndpoints } = endpoints;

export class S3FileService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get S3 File list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get S3 File list.
   */
  getS3FilesArray = async () => {
    const url = `${educationalElementEndpoints.s3}`;
    return this.http.get(url);
  };

  /**
   * Get S3 File info by key
   * @param { string } key - S3 File key.
   * @return { Object } - Get S3 File by.
   */
  getS3FileByKey = async (key) => {
    const url = `${educationalElementEndpoints.s3}/getUrlObjectByKey?key=${key}`;
    return this.http.get(url);
  };

  /**
   * Upload S3 File
   * @param { object } data - S3File data.
   * @return { promise } - The educationalElement promise object.
   */
  uploadS3File = async (data) => {
    const body = data;
    const url = educationalElementEndpoints.s3;
    return this.http.post(url, body);
  };

  /**
   * Delete S3 File by key
   * @param { string } key - S3File key.
   * @return { Object } - Get S3 File list.
   */
  deleteS3FileByKey = async (key) => {
    const url = `${educationalElementEndpoints.s3}?key=${key}`;
    return this.http.delete(url);
  };
}
export default new S3FileService(externalConnector);
